"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const common_1 = require("../../../../common");
const app_1 = require("../../app");
const functions_1 = require("../functions");
const Login_1 = require("./Login");
const styled_components_1 = __importDefault(require("styled-components"));
const Colors_1 = require("../../../../Colors");
const MyPageDropDownStyled = styled_components_1.default.div `
	.user {
		background: var(--color-white, #ffffff);
		border-radius: 20px;
		border-style: solid;
		border-color: var(--color-grey-c, #e6e8ed);
		border-width: 1px;
		padding: 6px 20px 6px 20px;
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;

		p {
			color: var(--color-black, #101010);
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b5-font-size, 12px) !important;
			line-height: var(--b5-line-height, 22px) !important;
			font-weight: var(--b4-font-weight, 400);
			position: relative;
			min-width: unset;
			top: 0;
			position: relative;
		}
	}

	.leave {
		justify-content: center;
		align-items: center;
		display: flex;
	}
`;
const MyPageDropDown = react_1.default.memo(({ isSidebar = false, iconOnly = false, iconColor, }) => {
    const [dropValue, setDropValue] = react_1.default.useState(undefined);
    const user_name = (0, react_redux_1.useSelector)((state) => (0, functions_1.getUserAuthName)(state));
    (0, react_1.useEffect)(() => {
        if (!dropValue)
            return;
        if (dropValue.id === 'account.logout') {
            localStorage.clear();
            (0, Login_1.deleteCookie)('refresh_token');
            (0, app_1.closeWindow)();
        }
    }, [dropValue]);
    return (react_1.default.createElement(MyPageDropDownStyled, null,
        react_1.default.createElement(common_1.Button, { className: iconOnly ? 'leave' : 'user', text: iconOnly ? undefined : '나가기', option: {
                buttonBeforeIcon: {
                    show: iconOnly,
                    name: 'logout_off',
                    size: 24,
                    color: iconColor || Colors_1.Colors.light_grey,
                },
                buttonAfterIcon: {
                    show: !iconOnly,
                    name: 'out',
                    size: 14,
                    color: Colors_1.Colors.light_grey,
                },
            }, onClick: () => {
                localStorage.clear();
                (0, Login_1.deleteCookie)('refresh_token');
                (0, app_1.closeWindow)();
            } })));
    // return (
    // 	<DropDown
    // 		className="user dropdown-mini"
    // 		value={{ id: user_name, title: '로그아웃' }}
    // 		list={[
    // 			// { id: 'account.information', title: 'account.information' },
    // 			{ id: 'account.logout', title: 'account.logout' },
    // 		]}
    // 		setDropValue={setDropValue}
    // 		styles={{
    // 			dropWrap: {
    // 				width: 130,
    // 			},
    // 			bodyItem: {
    // 				width: 143,
    // 			},
    // 		}}
    // 		option={{
    // 			downIcon: {
    // 				size: 10,
    // 			},
    // 		}}
    // 		isSidebar={isSidebar}
    // 	/>
    // );
});
exports.default = MyPageDropDown;
